import { logger, SafeMeta } from "@/core/logging";
import type { AgelessAssessmentFlowType } from "@orval/model";

export type AssessmentLogCode =
  | "ageless_assessment_token_expired_client_side"
  | "assessment_contact_missing_data_privacy_region"
  | "assessment_contact_save_failed"
  | "assessment_combined_pre_scan_missing_assessment_id"
  | "assessment_combined_pre_scan_submit"
  | "assessment_combined_pre_scan_submit_failed"
  | "assessment_front_photo_session_storage_write_failed"
  | "assessment_front_photo_session_storage_write_failed_error"
  | "assessment_pre_scan_missing_assessment_id"
  | "assessment_pre_scan_assessment_token_mismatch"
  | "assessment_pre_scan_submit"
  | "assessment_pre_scan_submit_failed"
  | "assessment_pre_scan_email_capture_failed"
  | "assessment_reveal_contact_session_storage_write_failed"
  | "assessment_reveal_contact_session_storage_write_failed_error"
  | "assessment_score_reveal_treatment_selection_error"
  | "assessment_wellness_pre_scan_draft_write_failed"
  | "assessment_wellness_pre_scan_draft_write_failed_error"
  | "assessment_wellness_pre_scan_missing_assessment_id"
  | "assessment_wellness_pre_scan_submit"
  | "assessment_wellness_pre_scan_submit_failed"
  | "assessment_pre_scan_missing_authorization_header"
  | "camera_session_start_failed"
  | "face_detection_unavailable_manual_capture_enabled"
  | "face_guidance_stuck_manual_capture_enabled"
  | "image_capture_confirm_failed"
  | "image_capture_crop_compress_failed"
  | "image_capture_device_info_failed"
  | "image_capture_upload_failed"
  | "lash_brow_eye_crop_compute_failed"
  | "lash_brow_eye_crop_upload_failed_error"
  | "lash_brow_eye_crop_upload_failed_non_fatal"
  | "photo_upload_confirm_failed"
  | "photo_upload_device_info_failed"
  | "photo_upload_front_failed"
  | "photo_upload_profile_failed"
  | "profile_alignment_stuck_manual_capture_enabled"
  | "profile_capture_compress_failed"
  | "profile_capture_upload_failed"
  | "studio_capture_session_storage_write_failed"
  | "studio_capture_session_storage_write_failed_error"
  | "studio_session_frontend_downscale_failed"
  | "studio_session_frontend_downscale_failed_error"
  | "studio_session_frontal_image_retrieve_failed"
  | "studio_session_frontal_image_upload_failed"
  | "studio_session_frontal_image_validation_retrieve_failed"
  | "studio_session_side_image_upload_failed"
  | "wellness_image_compression_failed"
  | "wellness_image_compression_failed_error";

type AssessmentMeta = {
  assessmentId: string;
  subdomainSlug: string;
  flowType: AgelessAssessmentFlowType;
} & SafeMeta;

export const assessmentLogger = {
  info: (code: AssessmentLogCode, meta: AssessmentMeta) => logger.info(code, meta),
  warn: (code: AssessmentLogCode, meta: AssessmentMeta) => logger.warn(code, meta),
  error: (code: AssessmentLogCode, meta: AssessmentMeta, cause: Error) =>
    logger.error(code, meta, cause),
};
